/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Share_MilestoneInputs */

const en_us2_share_share_milestone = /** @type {(inputs: Share_Share_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the milestone`)
};

const pt_br2_share_share_milestone = /** @type {(inputs: Share_Share_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar o marco`)
};

const es_419_share_share_milestone = /** @type {(inputs: Share_Share_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir el logro`)
};

const pt_pt2_share_share_milestone = /** @type {(inputs: Share_Share_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar o marco`)
};

const fr_fr2_share_share_milestone = /** @type {(inputs: Share_Share_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager le cap`)
};

const de_de2_share_share_milestone = /** @type {(inputs: Share_Share_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein teilen`)
};

const it_it2_share_share_milestone = /** @type {(inputs: Share_Share_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi il traguardo`)
};

/**
* | output |
* | --- |
* | "Share the milestone" |
*
* @param {Share_Share_MilestoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_share_milestone = /** @type {((inputs?: Share_Share_MilestoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Share_MilestoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_share_milestone(inputs)
	if (locale === "es-419") return es_419_share_share_milestone(inputs)
	if (locale === "pt-PT") return pt_pt2_share_share_milestone(inputs)
	if (locale === "fr-FR") return fr_fr2_share_share_milestone(inputs)
	if (locale === "de-DE") return de_de2_share_share_milestone(inputs)
	if (locale === "it-IT") return it_it2_share_share_milestone(inputs)
	return en_us2_share_share_milestone(inputs)
});
export { share_share_milestone as "share.share_milestone" }